import { useSavePersonMutation } from 'generated/graphql';
import React from 'react';

export function useRemoveSuperAdmin() {
  const [
    fnMutate,
    tuple
  ] = useSavePersonMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          input: {
            id,
            isSuperAdmin: false
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
